import { DeviationRequestsQueryFilter, DeviationTypesOption } from 'api/deviation-requests-list';
import { DeviationDetailType, DeviationRequestStatus, DeviationType, DeviationWorkflowType } from 'model/business-enums';
import { QueryFilter } from 'model/essential-types';

export class DeviationRequestsFilter implements QueryFilter, DeviationRequestsQueryFilter {
  constructor(public text: string = null, public from: string = null, public to: string = null, public statusValue: DeviationRequestStatus = null, public deviationTypesOption: DeviationTypesOption = null, public deviationType: DeviationType = null, public workflowType: DeviationWorkflowType = null, public detailType: DeviationDetailType = null, public includeArchived = false) { }

  canClear() {
    return this.text != null || this.from != null || this.to != null || this.statusValue != null || this.deviationTypesOption != null || this.includeArchived === true;
  }

  clear() {
    this.text = this.from = this.to = this.statusValue = this.deviationTypesOption = null;
    this.includeArchived = false;
  }
}
